module.exports = __webpack_public_path__ + "img/austria-neoplasm-male.5d983dae.png";